// import types
import {
  PlanningEntityIdentifier,
  SyncStatusResponse,
  SynchronizationStatusSummaryResponse
} from 'generated/index';
import {
  EntityProps,
  IdIsStringOrNumber,
  LinkValue
} from './SummaryCard.types';

// utils
import { formatEntityDisplayLabel } from 'components/mrp/mrp.utils';

// overloads to satisfy TypeScript's function overloading
export function toLinks<T extends EntityProps>(
  item: T | undefined,
  entityType: PlanningEntityIdentifier['planningEntityType']
): LinkValue | undefined;

export function toLinks<T extends EntityProps>(
  item: T[] | undefined,
  entityType: PlanningEntityIdentifier['planningEntityType']
): LinkValue[] | undefined;

// convert item to LinkValue or LinkValue[]
export function toLinks<T extends EntityProps>(
  item: T | T[] | undefined,
  entityType: PlanningEntityIdentifier['planningEntityType']
): LinkValue | LinkValue[] | undefined {
  if (!item) return undefined;

  const convert = (entity: T): LinkValue => {
    const rawId: IdIsStringOrNumber | undefined = entity.entityId ?? entity.id;
    const entityId = rawId != null ? String(rawId) : '';

    const rawLabel =
      entity.displayName ??
      entity.nameInformal ??
      entity.fullName ??
      entity.name ??
      entityId;

    const displayLabel = formatEntityDisplayLabel(rawLabel, entity.number);

    return {
      label: rawLabel.trim(),
      displayLabel: displayLabel.trim(),
      planningEntityIdentifier: {
        planningEntityType: entityType,
        entityId,
        number: entity.number
      }
    };
  };

  return Array.isArray(item) ? item.map(convert) : convert(item);
}

export function groupStatusByDestination(
  summary: SynchronizationStatusSummaryResponse
): Record<string, SyncStatusResponse> {
  const grouped: Record<string, SyncStatusResponse> = {};

  summary.synchronizationStatuses?.forEach((status) => {
    const destination = status.destination;
    if (!destination) return;

    grouped[destination] = status;
  });

  return grouped;
}
